<template>
    <div id="container">
        <keep-alive include="library">
            <transition :name="transitionName" mode="out-in">
                <router-view :key="refreshKey" />
            </transition>
        </keep-alive>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                refreshKey: 0,
                transitionName: 'slide-left'
            }
        },
        computed: {
            isMobile() {
                return window.innerWidth <= 768
            }
        },
        watch: {
            '$route'(to, from) {
                // 只在移动端启用过渡动画
                if (!this.isMobile) {
                    this.transitionName = ''
                    return
                }
                
                // 获取路由的 index 值，用于判断滑动方向
                const toIndex = to.meta && to.meta.index !== undefined ? to.meta.index : 0
                const fromIndex = from.meta && from.meta.index !== undefined ? from.meta.index : 0
                // 移动端滑动效果
                this.transitionName = toIndex > fromIndex ? 'slide-left' : 'slide-right'
            }
        },
        mounted() {
            // 监听全局刷新事件
            this.$root.$on('refresh-page', this.handleRefresh)
        },
        beforeDestroy() {
            // 组件销毁前移除事件监听
            this.$root.$off('refresh-page', this.handleRefresh)
        },
        methods: {
            handleRefresh() {
                this.refreshKey += 1
            }
        }
    }
</script>

<style scoped>
/* 容器样式 */
#container {
    position: relative;
    min-height: calc(100vh - 85px);
    background: transparent;
}

/* 移动端允许滚动但隐藏横向滚动条 */
@media (max-width: 768px) {
    #container {
        overflow-y: auto;
        overflow-x: hidden;
    }
}

/* 桌面端隐藏溢出内容用于过渡动画 */
@media (min-width: 769px) {
    #container {
        overflow: hidden;
    }
}

/* 移动端过渡动画 */
@media (max-width: 768px) {
    .slide-left-enter-active, .slide-left-leave-active,
    .slide-right-enter-active, .slide-right-leave-active {
        transition: all 0.15s cubic-bezier(0.165, 0.84, 0.44, 1);
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;
        right: 0;
    }

    /* 向左滑动（前进） */
    .slide-left-enter {
        transform: translateX(100%);
        opacity: 0;
    }

    .slide-left-leave-to {
        transform: translateX(-20%) scale(0.95);
        opacity: 0.3;
    }

    /* 向右滑动（后退） */
    .slide-right-enter {
        transform: translateX(-20%) scale(0.95);
        opacity: 0.3;
    }

    .slide-right-leave-to {
        transform: translateX(100%);
        opacity: 0;
    }
}
</style>
